import useDateRangeState from 'hooks/filterState/useDateRangeState';
import { useState } from 'react';
import { getURLParams, replaceURLParams } from 'utils/util';
import { BAR_VIEW_TYPE, PIE_VIEW_TYPE, UNIT_TYPE } from '../constants';
import usePagination from 'hooks/filterState/usePagination';
import { FilterDateMap } from 'utils/date';

const useFilter = () => {
  const params = getURLParams();
  const dateRangeState = useDateRangeState(() => paginationState.reset(), FilterDateMap.Yesterday);
  const paginationState = usePagination();

  const [barViewType, setBarViewType] = useState<string>(
    (params['barViewType'] as string) || Object.values(BAR_VIEW_TYPE())[0],
  );

  const [pieViewType, setPieViewType] = useState<string>(
    (params['pieViewType'] as string) || Object.values(PIE_VIEW_TYPE())[0],
  );

  const [unitType, setUnitType] = useState<string>(
    (params['unitType'] as string) || Object.values(UNIT_TYPE())[0],
  );

  const [tab, setTab] = useState<number>(Number(params['tab']) || 0);

  const tabState = {
    get: tab,
    set: (value: number) => {
      setTab(value);
      replaceURLParams({ tab: value });
    },
  };

  const barViewTypeState = {
    get: barViewType,
    set: (value: string) => {
      setBarViewType(value);
      replaceURLParams({ barViewType: value });
    },
  };

  const pieViewTypeState = {
    get: pieViewType,
    set: (value: string) => {
      setPieViewType(value);
      replaceURLParams({ pieViewType: value });
    },
  };

  const unitTypeState = {
    get: unitType,
    set: (value: string) => {
      setUnitType(value);
      replaceURLParams({ unitType: value });
    },
  };

  return {
    dateRange: dateRangeState,
    barViewType: barViewTypeState,
    pieViewType: pieViewTypeState,
    unitType: unitTypeState,
    tab: tabState,
    pagination: paginationState,
  };
};

export default useFilter;
